import type { CalcDef } from "./types.js";
import { tile } from "./calc/tile.js";
import { paint } from "./calc/paint.js";
import { flooring } from "./calc/flooring.js";
import { concrete } from "./calc/concrete.js";
import { roofing } from "./calc/roofing.js";
import { drywall } from "./calc/drywall.js";
import { mulch } from "./calc/mulch.js";
import { fence } from "./calc/fence.js";
import { deck } from "./calc/deck.js";
import { paver } from "./calc/paver.js";
import { wallpaper } from "./calc/wallpaper.js";
import { ac } from "./calc/ac.js";
import { insulation } from "./calc/insulation.js";
import { solar } from "./calc/solar.js";
import { baseboard } from "./calc/baseboard.js";

export const calculators: CalcDef[] = [
  tile, paint, flooring, concrete, roofing, drywall, mulch, fence, deck, paver,
  wallpaper, ac, insulation, solar, baseboard,
];

export function bySlug(slug: string): CalcDef | undefined {
  return calculators.find((c) => c.slug === slug);
}
